import { PaymentStatus } from '@/api/ariadne/__generated_types__/apollo';
import { BETA_FEATURES } from '@/constants';
import { AcceptCheckModalButton } from '@/controls/components/accept-check-modal';
import * as dataSelectors from '@/data/data-selectors';
import { TOP_LEVEL_TOT_TEST_IDS } from '@/top-level-tot/constants';
import { useGetDownloadTotSpreadsheetLink } from '@/top-level-tot/hooks/use-get-download-tot-spreadsheet-link';
import {
  PaymentPeriodDateRange,
  TopLevelTOTFilters,
} from '@/top-level-tot/types';
import { uiFiltersToServerFilters } from '@/top-level-tot/utils/ui-filters-to-server-filters';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { TOTReportDownloadButton } from './tot-report-download-button';

type Props = {
  period: PaymentPeriodDateRange;
  searchQuery: string;
  taxStatus: PaymentStatus | undefined;
  filters: TopLevelTOTFilters;
};

export function ActionsModule(props: Props) {
  const { period, searchQuery, taxStatus } = props;

  const isFeatureFlagEnabled = useSelector(
    dataSelectors.isBetaFeatureEnabled(BETA_FEATURES.acceptChecks)
  );

  const filters = useMemo(
    () => uiFiltersToServerFilters(props.filters),
    [props.filters]
  );

  const {
    totSpreadsheetDownloadLink,
    downloadLinkExpiration,
    isFetchingDownloadLink,
    downloadLinkFetchFailed,
    refetchDownloadLink,
  } = useGetDownloadTotSpreadsheetLink({
    period,
    searchQuery,
    taxStatus,
    filters,
  });

  return (
    <div
      data-testid={TOP_LEVEL_TOT_TEST_IDS.ACTIONS_CONTAINER}
      className="flex flex-col gap-2 align-end self-end"
    >
      <TOTReportDownloadButton
        downloadLink={totSpreadsheetDownloadLink}
        downloadLinkExpiration={downloadLinkExpiration}
        downloadLinkFetchFailed={downloadLinkFetchFailed}
        isFetchingDownloadLink={isFetchingDownloadLink}
        refetchDownloadLink={refetchDownloadLink}
      />

      {isFeatureFlagEnabled && <AcceptCheckModalButton />}
    </div>
  );
}
